import { css } from 'styled-components';
import { resolvePalette } from '@blade/ui-theme';
export const glassCss = ({ theme, disabled, $loading, $color, }) => {
    const base = css `
    border: none;
    color: var(--background-12);

    box-shadow: inset 0 0 0 1px var(--backgroundA-2);
  `;
    if ($loading) {
        return base;
    }
    if (disabled) {
        return css `
      color: var(--backgroundA-7);

      border-radius: 64px;
      box-shadow: inset 0px 0px 0px 1px var(--backgroundA-2);

      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.06) 0%,
        rgba(255, 255, 255, 0) 100%
      );
    `;
    }
    const stopColor = resolvePalette(theme, $color)[9] + '59';
    return css `
    ${base}

    background-color: var(--backgroundA-2);
    background-image: radial-gradient(
      64.13% 78.12% at 49.7% 100%,
      ${stopColor} 0%,
      rgba(82, 255, 0, 0) 100%
    );

    &:hover {
      background-color: var(--backgroundA-4);
    }
  `;
};
//# sourceMappingURL=button-styles-glass.js.map